module.exports = __webpack_public_path__ + "static/downloable/calendario_pagos_RRVV_2025.7465ce7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloable/calendario_pagos_RRVV_2025.pdf
// module id = d34l
// module chunks = 1